import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-modal-window',
	templateUrl: './modal-window.component.html',
	styleUrls: ['./modal-window.component.scss']
})


export class ModalWindowComponent implements OnInit {
	@Input() msg;
	constructor(public activeModal: NgbActiveModal) { }

	ngOnInit() {
	}

	dismiss() {
		this.activeModal.close({ result: false });
	}
}


// WEBPACK FOOTER //
// ./src/app/modal-window/modal-window.component.ts